(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/adobe-target-notification/assets/javascripts/notification-api.js') >= 0) return;  svs.modules.push('/components/components/adobe-target-notification/assets/javascripts/notification-api.js'); 'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getConfigValues = function getConfigValues() {
  if (svs.components && svs.components.adobeTargetNotification && svs.components.adobeTargetNotification.data && svs.components.adobeTargetNotification.data.config) {
    return svs.components.adobeTargetNotification.data.config;
  }

  throw new Error('Missing config for adobe target notification api');
};

var getEndpoint = function getEndpoint(_ref) {
  var serverDomain = _ref.serverDomain,
      client = _ref.client,
      sessionId = _ref.sessionId;
  return "https://".concat(serverDomain, "/rest/v1/delivery?client=").concat(client, "&sessionId=").concat(sessionId);
};

var apiCall = function apiCall(_ref2) {
  var config = _ref2.config,
      data = _ref2.data,
      _ref2$callback = _ref2.callback,
      callback = _ref2$callback === void 0 ? function () {} : _ref2$callback,
      _ref2$errorCallback = _ref2.errorCallback,
      errorCallback = _ref2$errorCallback === void 0 ? function () {} : _ref2$errorCallback;

  if (config.tntId) {
    if (window.navigator.sendBeacon) {
      var status = window.navigator.sendBeacon(getEndpoint(config), JSON.stringify(data)); 

      if (status) {
        callback({});
      } else {
        errorCallback({
          status: 400
        }, 'Couldnt add call to sendBeacon queue');
      }
    } else {
      $.ajax({
        type: 'POST',
        contentType: 'application/json',
        cache: false,
        url: getEndpoint(config),
        data: JSON.stringify(data),
        dataType: 'json',
        success: callback,
        error: errorCallback
      });
    }
  }
};

var createNotificationRequestObject = function createNotificationRequestObject(_ref3) {
  var tntId = _ref3.tntId,
      timestamp = _ref3.timestamp,
      propertyToken = _ref3.propertyToken,
      mboxName = _ref3.mboxName,
      tokens = _ref3.tokens,
      type = _ref3.type;
  var response = {
    id: {
      tntId: tntId
    },
    property: {
      token: propertyToken
    },
    context: {
      channel: 'web'
    },
    notifications: [{
      id: "".concat(mboxName, "Notification"),
      timestamp: timestamp,
      mbox: {
        name: mboxName
      },
      tokens: tokens,
      type: type
    }]
  }; 

  return response;
};

svs.components.adobeTargetNotification.display = function (_ref4, callback) {
  var mboxName = _ref4.mboxName,
      tokens = _ref4.tokens,
      state = _ref4.state,
      errorCallback = _ref4.errorCallback;
  var config = getConfigValues();
  var data = createNotificationRequestObject(_objectSpread(_objectSpread({}, config), {}, {
    mboxName: mboxName,
    tokens: tokens,
    state: state,
    type: 'display'
  }));
  apiCall({
    data: data,
    config: config,
    callback: callback,
    errorCallback: errorCallback
  });
};

svs.components.adobeTargetNotification.click = function (_ref5, callback) {
  var mboxName = _ref5.mboxName,
      tokens = _ref5.tokens,
      errorCallback = _ref5.errorCallback;
  var config = getConfigValues();
  var data = createNotificationRequestObject(_objectSpread(_objectSpread({}, config), {}, {
    mboxName: mboxName,
    tokens: tokens,
    type: 'click'
  }));
  apiCall({
    data: data,
    config: config,
    callback: callback,
    errorCallback: errorCallback
  });
};
 })(window);